/* Lazy load a build script on demand.
  Returns a promise that resolves once the script has loaded.

  Usage:
    lazyLoadScript({
      src: 'https://apu.edu.in/slider.min.b8a10cb6.js',
      sri: 'sha256-T8T56JyZc10Nl5OruwdGx4CKRnC9DzrmFMg0xssLWlU='
    }).then(() => initSliders(root));
*/
(function (window) {
  const requests = {};

  window.lazyLoadScript = (script) => {
    const src = script.src;

    if (!requests[src]) {
      requests[src] = new Promise((resolve, reject) => {
        const el = document.createElement('script');
        el.src = src;
        if (script.sri) {
          el.integrity = script.sri;
          el.crossOrigin = 'anonymous';
        }
        el.onload = () => resolve();
        el.onerror = () => {
          delete requests[src];
          reject(new Error('Failed to load ' + src));
        };
        document.head.appendChild(el);
      });
    }

    return requests[src];
  };
})(window);
